module.exports = function() { return __webpack_public_path__ + "intro_img2.3wSzZQPJM8kEMBlrFJqF.svg";};